
const networkCard = [
  {
    id: 1,
    title: 'Easy of use',
    titleTranslateKey: 'easeOfUseTitle',
    description: 'Useful information is never more than two clicks away. With no Java, Flash, clients to download, or agents to install, OmniCenter leads the industry in ease-of-use.',
    descriptionTranslateKey: 'easeOfUseDescription',
    imgName: 'smile.png'
  },
  {
    id: 2,
    title: 'Cloud Monitoring',
    titleTranslateKey: 'cloudMonitoringTitle',
    description: 'A wealth of features designed to monitor the availability, performance, response time, and SLA compliance for your mission-critical cloud applications.',
    descriptionTranslateKey: 'cloudMonitoringDescription',
    imgName: 'system-cloud.png'
  },
  {
    id: 3,
    title: 'Incident Management',
    titleTranslateKey: 'incidentManagementTitle',
    description: 'OmniCenter automatically avoids false alarms through automatic root cause analysis, rule-based correlation, and automated escalation.',
    descriptionTranslateKey: 'incidentManagementDescription',
    imgName: 'tools.png'
  },
  {
    id: 4,
    title: 'OmniCenter Voice',
    titleTranslateKey: 'voiceTitle',
    description: 'Unlike many competing telephony solutions, OmniCenter Voice collects call data from actual calls, not just simulated traffic.',
    descriptionTranslateKey: 'voiceDescription',
    imgName: 'phone-flip.png'
  },
  {
    id: 5,
    title: 'Virtualization Management',
    titleTranslateKey: 'virtualizationTitle',
    description: 'Whether you run Windows, Linux, Unix, Solaris, or even OS/400 and Z/OS, OmniCenter has the tools built-in to quickly and easily monitor, report, and alert on your server and back-end systems.',
    descriptionTranslateKey: 'virtualizationDescription',
    imgName: 'sql-server.png'
  },
  {
    id: 6,
    title: 'Configuration Management',
    titleTranslateKey: 'configManagementTitle',
    description: 'View your configuration changes in a timeline, calendar or list view and instantly see what parts of the configuration changed. It’s context-aware, and works with almost any configuration type you can think of.',
    descriptionTranslateKey: 'configManagementDescription',
    imgName: 'setting.png'
  },
  {
    id: 7,
    title: 'Mail Dashboard',
    titleTranslateKey: 'mailDashboardTitle',
    description: 'Provides a single pane-of-glass view into your enterprise email environment, synthetic mail transactions, end-to-end benchmarks.',
    descriptionTranslateKey: 'mailDashboardDescription',
    imgName: 'envelope.png'
  },
  {
    id: 8,
    title: 'Flow Analysis',
    titleTranslateKey: 'flowAnalysisTitle',
    description: 'Requires no agents, and instead uses standards-based or vendor-specific technologies and APIs to collect, monitor, analyze, and report on devices, applications, and performance. Allowing for seamless monitoring of any network-connected device or application hosted locally, in a private or public cloud environment.',
    descriptionTranslateKey: 'flowAnalysisDescription',
    imgName: 'flow-analysis.png'
  },
  {
    id: 9,
    title: 'Server Management',
    titleTranslateKey: 'serverManagementTitle',
    description: 'Whether you run Windows, Linux, Unix, Solaris, or even OS/400 and Z/OS, OmniCenter has the tools built-in to quickly and easily monitor, report, and alert on your server and back-end systems.',
    descriptionTranslateKey: 'serverManagementDescription',
    imgName: 'server.png'
  },
  {
    id: 10,
    title: 'Web ART',
    titleTranslateKey: 'webArtTitle',
    description: 'OmniCenter Web Application Response Time Monitor (Web ART) is designed to allow IT organizations to get a realistic view of user experience and easily identify the source of performance slowdowns.',
    descriptionTranslateKey: 'webArtDescription',
    imgName: 'health.png'
  },
  {
    id: 11,
    title: 'Monitoring & Data Collection',
    titleTranslateKey: 'monitoringCollectionTitle',
    description: 'Requires no agents, and instead uses standards-based or vendor-specific technologies and APIs to collect, monitor, analyze, and report on devices, applications, and performance. Allowing for seamless monitoring of any network-connected device or application hosted locally, in a private or public cloud environment.',
    descriptionTranslateKey: 'monitoringCollectionDescription',
    imgName: 'monitor.png'
  },
  {
    id: 12,
    title: 'Automated Mapping',
    titleTranslateKey: 'autoMappingTitle',
    description: 'Provides instant visual confirmation of network and device status for any size enterprise, with minimal configuration and maintenance.',
    descriptionTranslateKey: 'autoMappingDescription',
    imgName: 'mapping.png'
  },
]

export {
  networkCard
}
